import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import { first } from 'lodash';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { HomepageComponentTrackingNames } from '@reverbdotcom/commons/src/event_tracking/homepage';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import CmsListingsCollection, { ADDITIONAL_SORTS } from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import { getItem } from '@reverbdotcom/commons/src/local_storage_utils';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { ExperimentalPromotedListingsRowQuery } from '../../../schemas/rql';

interface ExternalProps {
  newHomepageDesign?: boolean;
}

type Props = ChildProps<ExternalProps, ExperimentalPromotedListingsRowQuery.Query>;

export function InternalPromotedListingsRow(props: Props) {
  const user = useUser();
  const { data } = props;
  const recentSearch: string | undefined = first(getItem('RECENT_SEARCHES', []));
  const topProductTypeUuids = data?.me?.profile?.topProductTypeUuids || [];

  const eligible = !data.loading && !!recentSearch && topProductTypeUuids.length > 0;

  useViewTracking({
    eventName: MParticleEventName.ComponentView,
    componentName: 'ExperimentalPromotedListingsRow', // Preserve view tracking name
    experiments: formatExperimentsForEventAttributes(user, []),
  }, eligible);

  return (
    <CmsListingsCollection
      componentName={HomepageComponentTrackingNames.HomepageBumpedListings}
      title={I18n.t('discovery.bumpsView.promotedListings')}
      sort={ADDITIONAL_SORTS.BUMP_BOOST}
      ssr={false}
      maxCount={props.newHomepageDesign ? 6 : 12}
      largeTiles={!props.newHomepageDesign}
    />
  );
}

const withQuery = withGraphql<Props, ExperimentalPromotedListingsRowQuery.Query>(
  gql`
    query Experimental_Promoted_Listings_Row_Query {
      me {
        uuid
        profile {
          topProductTypeUuids
        }
      }
    }
  `,
  {
    options: {
      ssr: false,
    },
  },
);

export const PromotedListingsRow = withQuery(InternalPromotedListingsRow);
